module.exports = __webpack_public_path__ + "img/gpt-addin-02.6f7b577d.png";